import React from 'react'
import { toFixedThree } from '../../utility/helper';

interface ProductData {
    sales: number;
    count: number
}
const TopProducts: React.FC<{ products: Record<string, ProductData> }> = ({ products }) => {

    const sortedProducts = Object.entries(products ?? {})
        .sort((a, b) => b[1].count - a[1].count).slice(0, 10);

    return (
        <div className="app-card app-card-orders-table shadow-sm mb-4">
            <div className="p-4">
                <h5 className="mb-4 card-title">Top Selling Products</h5>
                <div className="table-responsive">
                    <table className="table">
                        <thead>
                            <tr>
                                <th>Product</th>
                                <th>Orders</th>
                                <th>Sales</th>
                            </tr>
                        </thead>
                        <tbody>
                            {sortedProducts.map(([name, data], index) => (
                                <tr key={index}>
                                    <td>{name}</td>
                                    <td>{data.count}</td>
                                    <td>{toFixedThree(data.sales)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default TopProducts;